const addresses = {
	title: "Addresses",
	stitle: "Address",
	new_address: "New Address",
	edit_address: "Edit Address",
	view_address: "View Address",
	list_title: "List of Addresses",
	list_subtitle: "Manage Address",
	create_title: "Create New Address",
	update_title: "Update Address",
	details_title: "Address Details",
	id: "ID",
	name: "Name",
	street: "Street",
	city: "City",
	state: "State",
	zip: "Zip",
	country: "Country",
	comments: "Comments",
	status: "Status",
};
export default addresses;